export default "__VITE_ASSET__DxntZM$___"